<template>
  <v-dialog :model-value="isVisible" persistent width="640">
    <v-card class="agreement-modal">
      <v-card-title class="agreement-modal__header">Необходимо действие пользователя</v-card-title>
      <div class="agreement-modal__body">
        <v-card-text class="pb-0">
          <v-checkbox v-model="isChecked" color="primary" hide-details>
            <template #label>
              <span v-html="noticeText" />
            </template>
          </v-checkbox>
        </v-card-text>
        <v-card-text class="pt-2">
          <div class="d-flex flex-column ga-2 pl-12 mt-4">
            <div
              v-for="(link, index) in agreementLinks"
              :key="index"
              class="text-grey cursor-pointer mt-1"
              @click="openFile(link)"
            >
              {{ link.title }}
            </div>
          </div>
        </v-card-text>
      </div>
      <v-card-actions class="agreement-modal__footer d-flex justify-end pb-4 px-6">
        <v-btn :disabled="!isChecked || loading" color="primary" @click="accept">Принять</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { api } from '@/api/Api'
import { useToast } from '@/composables/useToast'

const store = useStore()
const { toast } = useToast()

const noticeText = ref('')
const noticeLoaded = ref(false)
const isChecked = ref(false)
const loading = ref(false)

const agreementLinks = ref([
  {
    title: 'Пользовательское соглашение',
    href: '/Пользовательское соглашение.pdf',
  },
  {
    title: 'Политика конфиденциальности',
    href: '/Политика конфиденциальности.pdf',
  },
])

const hasAgreement = computed(() => {
  const agreement = store.getters['user/userInfo']?.agreement
  return agreement === true || agreement === 1 || agreement === 'Y'
})

const isVisible = computed(() => {
  if (!noticeLoaded.value || hasAgreement.value) {
    return false
  }
  return noticeText.value.trim().length > 0
})

const getNoticeText = async () => {
  try {
    const response = await api.user().getAgreementNotice()
    noticeText.value = response?.text ?? ''
  } catch (err) {
    if (err?.response?.data?.message) {
      toast.error(err.response.data.message)
    }
  } finally {
    noticeLoaded.value = true
  }
}

const accept = async () => {
  loading.value = true
  try {
    await api.user().confirmAgreement()
    await store.dispatch('user/getUserInfo')
    isChecked.value = false
  } catch (err) {
    if (err?.response?.status === 409) {
      await store.dispatch('user/getUserInfo')
      return
    }
    if (err?.response?.status === 500) {
      toast.error('Не удалось сохранить согласие. Попробуйте позже.')
      return
    }
    toast.error(err?.response?.data?.message || 'Не удалось подтвердить согласие.')
  } finally {
    loading.value = false
  }
}

async function openFile(link) {
  window.open(link.href, '_blank')?.focus()
}

onMounted(() => {
  getNoticeText()
})
</script>

<script>
export default {
  name: 'TheAgreement',
}
</script>
<style scoped>
.agreement-modal {
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.agreement-modal__header {
  flex-shrink: 0;
}

.agreement-modal__body {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.agreement-modal__footer {
  flex-shrink: 0;
}
</style>
